export const GET_ALL_ENQUIRY_LIST = "GET_ALL_ENQUIRY_LIST"
export const ALL_ENQUIRY_LIST = "ALL_ENQUIRY_LIST"
export const UPDATE_ENQUIRY = "UPDATE_ENQUIRY"
export const DONE_PROCESS = "DONE_PROCESS"
export const SEARCH_ENQUIRY = "SEARCH_ENQUIRY"
